/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_TaglineInputs */

const en_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Powered Job Applications for Europe`)
};

const de_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestützte Bewerbungen für Europa`)
};

const fr_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures alimentées par l'IA pour l'Europe`)
};

const es_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes de empleo con IA para Europa`)
};

const it_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature al lavoro potenziate dall'AI per l'Europa`)
};

const nl_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-gestuurde sollicitaties voor Europa`)
};

const pl_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje o pracę napędzane AI — dla Europy`)
};

const fi_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyä hyödyntävät työhakemukset Euroopassa`)
};

const da_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-drevet jobansøgninger til Europa`)
};

const sv_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-drivna jobbansökningar för Europa`)
};

/**
* | output |
* | --- |
* | "AI-Powered Job Applications for Europe" |
*
* @param {App_TaglineInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const app_tagline = /** @type {((inputs?: App_TaglineInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_TaglineInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_app_tagline(inputs)
	if (locale === "fr") return fr_app_tagline(inputs)
	if (locale === "es") return es_app_tagline(inputs)
	if (locale === "it") return it_app_tagline(inputs)
	if (locale === "nl") return nl_app_tagline(inputs)
	if (locale === "pl") return pl_app_tagline(inputs)
	if (locale === "fi") return fi_app_tagline(inputs)
	if (locale === "da") return da_app_tagline(inputs)
	if (locale === "sv") return sv_app_tagline(inputs)
	return en_app_tagline(inputs)
});